import React from 'react'
import { SvgIcon } from '@mui/material'

export const PendingStatusIcon = props => (
  <SvgIcon
    viewBox="0 0 20 20"
    {...props}
    sx={{ width: '20px', height: '20px' }}
  >
    <path
      d="M12.5 9.166h-1.666V5.833a.833.833 0 1 0-1.667 0v4.166a.833.833 0 0 0 .833.834h2.5a.833.833 0 0 0 0-1.667zm-2.5-7.5a8.333 8.333 0 1 0 0 16.667 8.333 8.333 0 0 0 0-16.667zm0 15a6.667 6.667 0 1 1 0-13.334 6.667 6.667 0 0 1 0 13.334z"
      fill="#818181"
    />
  </SvgIcon>
)
